export default {
    en: {
        amount_send: 'You send exactly',
        amount: 'Amount',
        sender_name: 'Sender name',
        name_send: `Beneficiary's full name`,
        name_placeholder: 'John Wick',
        phone_send: `Beneficiary's phone number`,
        card_send: `Beneficiary's card number`,
        account_send: `Beneficiary's account number`,
        recipient_list: `Recipient list`,
        select_recipient: `Select recipient`,
        choose_recipient: `Choose recipient`,
        create_recipient: 'Create new recipient',
        description: `Description`,
        description_text: `Describe the purpose of the deal`,
        payment_method: `Choose payment system`,
        bank_list: `Choose bank`,
        pay_comission_title: 'Payment system commission',
        our_comission_title: 'Our commission',
        guaranteed_rate: 'Guaranteed rate',
        exchange_rate: 'Exchange rate',
        guaranteed_rate_total: 'Total guaranteed rate',
        guaranteed_time: '15 minutes',
        time_title: 'Transfer time',
        limits_title: 'Limits for deal',
        limits_text: 'In 15 minutes from the moment the transfer was created, the exchange rate will not change. In case of unsuccessful payment, the transfer will automatically close after 15 minutes.',
        amount_receive: 'The recipient will receive (you)',
        select_currency: 'Select currency',
        translation_time: 'Translation time: 15 minutes',
        button: 'Create a deal',
        before: 'Pre-registration required',
        first_transfer: 'You have a test transfer for 500 rubles',
        do_first_transfer: 'Make a first transfer',
        first_transfer_title: 'What is a test transfer?',
        first_transfer_text: 'For the first time, you can transfer only 500 rubles in order to make sure of the quality of our service. After a successful transfer, you will be able to transfer amounts according to the limits.',
        success_title: 'Success',
        success_subtitle: 'Deal created successfully',
        error_title: 'Error',
        critical_error: 'Critical error',
        post: 'Post'
    },
    ru: {
        amount_send: 'К отправке',
        amount: 'Сумма',
        sender_name: 'Имя отправителя',
        name_send: `Имя и фамилия получателя (на англ)`,
        name_placeholder: 'Ivan Petrov',
        phone_send: `Номер телефона получателя`,
        card_send: `Номер карты получателя`,
        account_send: `Номер счета получателя`,
        recipient_list: `Список получателей`,
        choose_recipient: `Выберите получателя`,
        select_recipient: `Выбрать получателя`,
        create_recipient: 'Создать нового получателя',
        description: `Описание`,
        description_text: `Опишите ваш товар или услугу`,
        payment_method: `Выберите банк отправителя (ваш банк)`,
        bank_list: `Выберите банк получателя`,
        pay_comission_title: 'Комиссия платежной системы',
        our_comission_title: 'Наша комиссия',
        guaranteed_rate: 'Обменный курс',
        exchange_rate: 'Биржевой курс',
        guaranteed_rate_total: 'Итоговый обменный курс',
        guaranteed_time: '15 минут',
        time_title: 'Время перевода',
        limits_title: 'Лимиты за сделку',
        limits_text: 'В течение 15 минут с момента создания перевода курс обмена не изменится. В случае неоплаты перевод автоматически закроется через 15 минут.',
        amount_receive: 'Получатель получит (вы)',
        select_currency: 'Выберите валюту',
        translation_time: 'Время перевода: 15 минут',
        button: 'Создать сделку',
        before: 'Предварительно необходимо пройти регистрацию',
        first_transfer: 'Вам доступен тестовый перевод на 500 рублей',
        do_first_transfer: 'Сделать тестовый перевод',
        first_transfer_title: 'Что такое тестовый перевод?',
        first_transfer_text: 'В первый раз вы можете перевести всего 500 рублей для того, чтобы убедиться в качестве нашего сервиса. После успешного перевода вы сможете переводить суммы согласно лимитам.',
        success_title: 'Успех',
        success_subtitle: 'Сделка успешно создан',
        error_title: 'Ошибка',
        critical_error: 'Критическая ошибка',
        post: 'Объявление'
    }
}